import { Container } from '@/app/components/layouts/container';
import type { MaintenanceListSelectsProps } from '@/app/components/sections/service/maintenance-list/selects';
import { MaintenanceListSelects } from '@/app/components/sections/service/maintenance-list/selects';
import { MAINTENANCE_LIST_DATA_TEST } from '@/app/components/sections/service/maintenance-list/tracking';
import type { VehicleType } from '@/app/types/vehicle-type';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

interface MaintenanceListSearchHeaderProps extends MaintenanceListSelectsProps {
  vehicleType: VehicleType;
  disabled?: boolean;
}

export const MaintenanceListSearchHeader = (
  props: MaintenanceListSearchHeaderProps
) => {
  return (
    <Container
      as="section"
      className={cn('grid gap-4 pb-10', {
        'lg:grid-cols-3': props.vehicleType === 'lcv',
        'md:grid-cols-2 lg:grid-cols-4': props.vehicleType === 'cv',
      })}
      {...createDataAttributes({
        test: MAINTENANCE_LIST_DATA_TEST.searchHeader,
      })}
    >
      <MaintenanceListSelects {...props} />
    </Container>
  );
};
